import { CountryDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadCountry = createAction('[Country] Load Country');

export const loadCountrySuccess = createAction(
  '[Country] Load Country Success',
  props<{ country: CountryDto[] }>()
);

export const loadCountryFailure = createAction(
  '[Country] Load Country Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addCountry = createAction(
  '[Country] Add Country',
  props<{ newCountry: CountryDto[] }>()
);

export const addCountrySuccess = createAction(
  '[Country] Add Country Success',
  props<{ newCountry: CountryDto[] }>()
);

export const addCountryFailure = createAction(
  '[Country] Add Country Failure',
  props<{ error: any }>()
);

/**
 * Update Country Collection Actions
 */
export const updateCountry = createAction(
  '[Country] Update Country',
  props<{ updateCountry: CountryDto[] }>()
);

export const updateCountrySuccess = createAction(
  '[Country] Update Country Success',
  props<{ updateCountry: CountryDto[] }>()
);

export const updateCountryFailure = createAction(
  '[Country] Update Country Failure',
  props<{ error: any }>()
);

/**
 * Remove Country Collection Actions
 */
export const removeCountry = createAction(
  '[Country] Remove Country',
  props<{ ids: string[] }>()
);

export const removeCountrySuccess = createAction(
  '[Country] Remove Country Success',
  props<{ ids: string[] }>()
);

export const removeCountryFailure = createAction(
  '[Country] Remove Country Failure',
  props<{ error: any }>()
);
